import {Directive, forwardRef, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';

export interface PasswordValidationRule {
  validation: string;
  message: string;
  regex: RegExp;
}

@Directive({
    selector: '[passwordValidator][ngModel],[passwordValidator][formControl]',
    providers: [{
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PasswordValidator),
            multi: true
        }],
    standalone: true
})
export class PasswordValidator implements Validator {
  @Input() validationRules: PasswordValidationRule[] = [
    { validation: '^.{8,}$', message: 'Password must be at least 8 characters long', regex: new RegExp('^.{8,}$') },
    { validation: '[A-Z]', message: 'Password must contain at least one uppercase letter', regex: new RegExp('[A-Z]') },
    { validation: '[a-z]', message: 'Password must contain at least one lowercase letter', regex: new RegExp('[a-z]') },
    { validation: '[0-9]', message: 'Password must contain at least one number', regex: new RegExp('[0-9]') }
  ];

  constructor() {
  }

  validate(c: AbstractControl): { [key: string]: any } {
    // Make sure a value is specified
    if (!c.value) {
      return {missingValue: true};
    }

    // Check each validation rule
    for (const rule of this.validationRules) {
      if (!rule.regex.test(c.value)) {
        return {invalid: rule.message};
      }
    }

    return null;
  }
}
